/** Screen-space sizing for the frame-length dimension drawn beside a frame. */
export const FrameLengthDimension = {
	/** Gap left between the dimension line and each frame endpoint. */
	endpointPaddingScreenPx: 12,
	/** ROME danger red — distinct from the gold measure-tool labels. */
	color: 0xef4444,
	/** How far the dimension line sits off the frame. */
	offsetScreenPx: 22,
	/** Arrow head length along the dimension line. */
	arrowLengthScreenPx: 8,
	/** Arrow head half-width across the dimension line. */
	arrowHalfWidthScreenPx: 4,
	/** Gap between text and line, as a fraction of line height. */
	textGapLineHeightRatio: 1 / 5,
	/** Padding around the dimension text. */
	textPaddingScreenPx: 1,
	/** Dimension text size. */
	fontSizeScreenPx: 14,
	/** Longest the text may run, as a fraction of the frame length. */
	textMaxLengthRatio: 0.8,
	/** Stroke width before clamping to world units. */
	strokeScreenPx: 1,
	/** Lower clamp on the stroke width in world units. */
	strokeMinWorld: 0.03,
	/** Upper clamp on the stroke width in world units. */
	strokeMaxWorld: 3.5,
} as const;
